export const bankOptions = [
  {
    "name": "Abu Dhabi Commercial Bank",
    "short": "ADCB",
    "type": "traditional"
  },
  {
    "name": "Abu Dhabi Islamic Bank",
    "short": "ADIB",
    "type": "traditional"
  },
  {
    "name": "Ajman Bank",
    "short": "Ajman",
    "type": "traditional"
  },
  {
    "name": "Commercial Bank International",
    "short": "CBI",
    "type": "traditional"
  },
  {
    "name": "Central Bank of the UAE",
    "short": "CBUAE",
    "type": "traditional"
  },
  {
    "name": "Commercial Bank of Dubai",
    "short": "CBD",
    "type": "traditional"
  },
  {
    "name": "Dubai Islamic Bank",
    "short": "DIB",
    "type": "traditional"
  },
  {
    "name": "Emirates NBD",
    "short": "ENBD",
    "type": "traditional"
  },
  {
    "name": "Emirates Islamic Bank",
    "short": "Emirates Islamic",
    "type": "traditional"
  },
  {
    "name": "National Bank of Fujairah",
    "short": "NBF",
    "type": "traditional"
  },
  {
    "name": "RAKBANK",
    "short": "RAK",
    "type": "traditional"
  },
  {
    "name": "Saudi National Bank (UAE Branch)",
    "short": "SNB",
    "type": "traditional"
  },
  {
    "name": "Sharjah Islamic Bank",
    "short": "SIB",
    "type": "traditional"
  },
  {
    "name": "Standard Chartered Bank UAE",
    "short": "Standard Chartered",
    "type": "traditional"
  },
  {
    "name": "UBS (UAE)",
    "short": "UBS",
    "type": "traditional"
  },
  {
    "name": "United Arab Bank",
    "short": "UAB",
    "type": "traditional"
  },
  {
    "name": "HSBC Middle East UAE",
    "short": "HSBC",
    "type": "traditional"
  },
  {
    "name": "Mashreq Bank",
    "short": "Mashreq",
    "type": "traditional"
  },
  {
    "name": "Liv. by Emirates NBD",
    "short": "Liv",
    "type": "digital"
  },
  {
    "name": "YAP",
    "short": "YAP",
    "type": "digital"
  },
  {
    "name": "Mashreq Neo",
    "short": "Neo",
    "type": "digital"
  },
  {
    "name": "ADIB Smartbanking",
    "short": "ADIB Smart",
    "type": "digital"
  },
  {
    "name": "ADIB Amwali",
    "short": "Amwali",
    "type": "digital"
  },
  {
    "name": "Zand Bank",
    "short": "Zand",
    "type": "digital"
  },
  {
    "name": "Wio Bank",
    "short": "Wio",
    "type": "digital"
  },
  {
    "name": "E20 by Emirates NBD",
    "short": "E20",
    "type": "digital"
  },
  {
    "name": "OneSafe",
    "short": "OneSafe",
    "type": "digital"
  },
  {
    "name": "Al Maryah Community Bank",
    "short": "mbank",
    "type": "digital"
  }
]